import {
  ODSFooter,
  ODSFooterMenuItem,
  ODSToast,
} from "@telekom-ods/react-ui-kit";
import { InstagramIcon, LinkedinIcon } from "dt-components";

import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  StyledFooterSection,
  StyledIconWrapper,
  StyledToastWrapper,
} from "src/routes/page/site/styles";
import { footerImages } from "../Career/constant";
// import { subscribe } from "src/services/customSiteQueries";

const defaultToastValue = {
  title: "",
  message: "",
  show: false,
  type: "success",
};
const footerLinks = [
  { label: "Disclaimer", href: "disclaimer" },
  { label: "Privacy Policy", href: "privacypolicy" },
  { label: "Corporate Social Responsibility", href: "csrpolicy" },
  { label: "Whistleblower Policy", href: "whistleblower" },
  // { label: "Annual Return", href: "annualreport" }
];
type ODSTypeType = "success" | "information";
export const FooterWrapper = () => {
  // const [email, setEmail] = useState("");
  const [toastData, setToastData] = useState(defaultToastValue);

  // const handleSubscribe = async () => {
  //   try {
  //     const response = await subscribe(
  //       { email: email },
  //       "cc7e877e-e254-4f72-b2ad-6dec6083474a"
  //     );
  //     if (response) {
  //       setToastData({
  //         title: "Subscribe sucess",
  //         message: "You have subscribe successfully",
  //         show: true,
  //         type:'success'
  //       });
  //     }
  //   } catch (e) {
  //     setToastData({
  //       title: "Subscribe Failed",
  //       message: "Failed to Subscribe, Plese try again",
  //       show: true,
  //       type:'information'
  //     });
  //   }
  // };
  const OldFooter = () => (
    <>
      <StyledIconWrapper
        href="https://www.instagram.com/dtdllife/"
        target="_blank"
      >
        <InstagramIcon color="black" size="large" />
      </StyledIconWrapper>
      <StyledIconWrapper
        target="_blank"
        href="https://medium.com/deutsche-telekom-gurgaon"
      >
        <img
          src={
            "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/1308181725689905_Button.svg&alt=medium"
          }
        />
      </StyledIconWrapper>
      <StyledIconWrapper
        target="_blank"
        href="https://www.linkedin.com/company/deutsche-telekom-digital-labs"
      >
        <LinkedinIcon color="black" size="large" />
      </StyledIconWrapper>
    </>
  );

  const footerContent = () => {
    const hasFooterImages = Object.keys(footerImages).length > 0;
    return (
      <StyledFooterSection>
        <div className="footer-main-heading">
          <div className="social-icon">
            {hasFooterImages ? (
              Object.keys(footerImages).map((key) => {
                const { href, imageUrl } = footerImages[key];
                return (
                  <StyledIconWrapper href={href} target="_blank" key={key}>
                    <img src={imageUrl} alt={`${key}-icon`} />
                  </StyledIconWrapper>
                );
              })
            ) : (
              <OldFooter />
            )}
          </div>
        </div>
      </StyledFooterSection>
    );
  };

  return (
    <>
      <ODSFooter
        data-scheme="white"
        className="ods-footer"
        copyrightText="© Deutsche Telekom Digital Labs Private Limited"
        logoProps={{
          "aria-label": "Deutsche Telekom Digital Labs Private Limited",
          href: "/",
          title: "DTDL Home",
          variant: "primary",
        }}
        variant="standard"
        contentSlot={footerContent()}
      >
        {footerLinks.map((item) => {
          return (
            <ODSFooterMenuItem asChild>
              <Link to={item.href}>{item.label}</Link>
            </ODSFooterMenuItem>
          );
        })}
      </ODSFooter>
      <StyledToastWrapper>
        <ODSToast
          onClose={function closeToast() {
            setToastData(defaultToastValue);
          }}
          timeout={3000}
          title={toastData.message}
          type={toastData.type as ODSTypeType}
          opened={toastData.show}
        />
      </StyledToastWrapper>
    </>
  );
};

export default FooterWrapper;
